// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Gq75","rootNoMargin":"styles_rootNoMargin__jCBhw"};